import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { WirelessHealthDetail } from "../../../../../../apis/networkdashboard/rest/models";
import { LoaderComponent } from "../../../../../../components/common/loader/loader";
import { KpiTableComponent } from "../../../../../../components/subscription-detail/kpi-table/kpi-table";
import { WirelessSubscriptionDetails } from "../../../../types";

@Component({
  selector: "kpi-section",
  templateUrl: "kpi-section.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, KpiTableComponent, LoaderComponent, TranslatePipe],
})
export class KpiSectionComponent {
  protected subscription = input.required<WirelessSubscriptionDetails>();
  protected kpis = input.required<WirelessHealthDetail>();

  protected sensorPresent = computed(() => this.subscription().sensorPresent);
  protected vendor = computed(() => this.subscription().supplier?.toLowerCase());
}
